import { amplitudeLib } from 'freedom-shared';

import type { SpecialOfferFriendsParams } from '../analytics/special-offers';

/**
 * @description Открытие баннера спец предложений
 * @trigger При загрузке деталей спец предложения
 * @location Карточки спец предложений
 */
export const specialOffersBannerOpened = ({
  bannerId,
  bannerName,
  bannerType,
  source,
}: {
  bannerId: string;
  bannerName: string;
  bannerType: 'flights' | 'events';
  source: 'main' | 'all_special_offers';
}) => {
  amplitudeLib.logEvent('avfree_special_offers_banner_opened', {
    banner_id: bannerId,
    banner_name: bannerName,
    banner_type: bannerType,
    source,
  });
};

/**
 * @description Открытие страницы всех спец предложений
 * @trigger При нажатии на кнопку "Все предложения"
 * @location Карусель спец предложений на главной странице
 */
export const allSpecialOffersPageOpened = () => {
  amplitudeLib.logEvent('avfree_all_special_offers_page_opened');
};

/**
 * @description Клик по спец предложению
 * @trigger При нажатии на карточку предложения когда есть currentSpecialOffer
 * @location OffersCarousel и OffersVerticalListBlock
 */
export const specialOffersClicked = ({
  bannerId,
  bannerName,
  bannerType,
  source,
}: {
  bannerId: string;
  bannerName: string;
  bannerType: 'flights' | 'events';
  source: 'main' | 'all_special_offers';
}) => {
  amplitudeLib.logEvent('avfree_special_offers_clicked', {
    banner_id: bannerId,
    banner_name: bannerName,
    banner_type: bannerType,
    source,
  });
};

/**
 * @description Показ хардкод-баннера Freedom Lifestyle (A/B `avfree_special_offer_friends`)
 * @trigger Когда пользователь попадает в вариант `on` и карусель отрендерила карточку
 * @location Карусель спец предложений на главной странице
 */
export const specialOfferFriendsShown = (params: SpecialOfferFriendsParams) => {
  amplitudeLib.logEvent('avfree_special_offer_friends_shown', params);
};

/**
 * @description Клик по хардкод-баннеру Freedom Lifestyle (A/B `avfree_special_offer_friends`)
 * @trigger При нажатии на карточку или CTA-кнопку
 * @location Карусель спец предложений на главной странице
 */
export const specialOfferFriendsClicked = (
  params: SpecialOfferFriendsParams,
) => {
  amplitudeLib.logEvent('avfree_special_offer_friends_click', params);
};
